import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { AuthService } from "../../../core/services/auth.service";

@Component({
    selector: "app-verify-email",
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatProgressSpinnerModule,
    ],
    templateUrl: "./verify-email.html",
    styleUrls: ["./verify-email.scss"],
})
export class VerifyEmailComponent implements OnInit {
    loading: boolean = true;
    verified: boolean = false;
    error: string = "";
    currentYear: number = new Date().getFullYear();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            const token = params["token"];
            if (token) {
                this.verifyEmail(token);
            } else {
                this.error = "Verification token is missing";
                this.loading = false;
            }
        });
    }

    verifyEmail(token: string): void {
        this.authService.verifyEmail(token).subscribe({
            next: (response) => {
                this.verified = true;
                this.loading = false;
            },
            error: (err) => {
                this.error = err.message || "Email verification failed. The link may have expired or is invalid.";
                this.loading = false;
            },
        });
    }

    goToLogin(): void {
        this.router.navigate(["/login"]);
    }
}
